import { Dialog, DialogContent } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import React, { PropsWithChildren, useEffect } from 'react';
import { colorMap } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

import { DialogModalContentProps } from './DialogModalContent.interface';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '& .MuiDialogContent-root': {
        padding: 0,
      },

      '& .MuiDialog-paperWidthSm': {
        maxWidth: 'none',
      },

      [muiTheme.breakpoints.down('xs')]: {
        '& .MuiDialog-paper': {
          margin: 0,
        },

        '&.MuiPaper-rounded': {
          borderRadius: 0,
        },
      },
    },
    backdrop: {
      backgroundColor: `${hexToRGBA(colorMap.black, 0.95)} !important`,
    },
  }),
  { name: 'GenDialogModalContent' },
);

const DialogModalContent = ({
  className,
  title,
  description,
  children,
  toggleOpen,
  isOpen = false,
  keepMounted = false,
}: PropsWithChildren<DialogModalContentProps>) => {
  const classes = useStyles();

  useEffect(() => {
    document.documentElement.style.overflow = isOpen ? 'hidden' : '';
  }, [isOpen]);

  return (
    <div>
      <Dialog
        className={classes.root}
        aria-labelledby={title}
        aria-describedby={description}
        open={isOpen}
        onClose={toggleOpen}
        BackdropComponent={Backdrop}
        BackdropProps={{ className: classes.backdrop }}
        keepMounted={keepMounted}
        scroll="body"
      >
        <DialogContent className={className}>{children}</DialogContent>
      </Dialog>
    </div>
  );
};

export default DialogModalContent;
